import type { TodoDueKind, TodoNoteItemDraft } from '../types/todoNote';

/** 동일 마감 버킷 내에서만 드래그 정렬 (D:일자 / M:연-월) */
export function todoItemBucketKey(item: Pick<TodoNoteItemDraft, 'due_kind' | 'due_date'>): string {
  if (item.due_kind === 'month') {
    const d = item.due_date.slice(0, 7); // YYYY-MM
    return `M:${d}`;
  }
  return `D:${item.due_date}`;
}

/** 전역 정렬: 과거→미래. 동일 due_date면 month가 day보다 앞(같은 1일 기준 월 단위가 먼저 보이도록) */
export function compareTodoItemsForSort(a: TodoNoteItemDraft, b: TodoNoteItemDraft): number {
  if (a.due_date !== b.due_date) return a.due_date < b.due_date ? -1 : 1;
  if (a.due_kind !== b.due_kind) return a.due_kind === 'month' ? -1 : 1;
  if (a.bucket_order !== b.bucket_order) return a.bucket_order - b.bucket_order;
  return a.id.localeCompare(b.id);
}

export function sortTodoItemsDrafts(items: TodoNoteItemDraft[]): TodoNoteItemDraft[] {
  return [...items].sort(compareTodoItemsForSort);
}
